export enum GroupMembershipTypeEnum {
  OWNER = 'owner',
  MEMBER = 'member'
}

